import React, { useEffect, useState, useMemo } from 'react';
import videoSmall from '../../Videoclipuri/betonHomePage.mp4';
import videoLarge from '../../Videoclipuri/betonHomePageBiggerSize.mp4';
import posterDesktop from '../../Imagini/hero-poster-desktop-1600x900.webp';
import posterMobile from '../../Imagini/hero-poster-mobile-800x1000.webp';

const MOBILE_BREAKPOINT = 768;

const Video = () => {
  const getIsMobile = () =>
    typeof window !== 'undefined' ? window.innerWidth <= MOBILE_BREAKPOINT : false;

  const [isMobile, setIsMobile] = useState(getIsMobile());
  const [shouldLoadVideo, setShouldLoadVideo] = useState(false);

  useEffect(() => {
    const handleResize = () => setIsMobile(getIsMobile());
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  useEffect(() => {
    const timer = setTimeout(() => {
      setShouldLoadVideo(true);
    }, 1200);

    return () => clearTimeout(timer);
  }, []);

  const videoSource = useMemo(
    () => (isMobile ? videoSmall : videoLarge),
    [isMobile]
  );

  const posterSource = useMemo(
    () => (isMobile ? posterMobile : posterDesktop),
    [isMobile]
  );

  return (
    <video
      autoPlay={shouldLoadVideo}
      muted
      loop
      playsInline
      preload="none"
      poster={posterSource}
      style={{
        width: '100%',
        height: '100%',
        objectFit: 'cover',
        display: 'block',
      }}
    >
      {shouldLoadVideo && <source src={videoSource} type="video/mp4" />}
      Your browser does not support the video tag.
    </video>
  );
};

export default Video;